<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-ura-contract-individual
    [merchandiseDivisionCd]="merchandiseDivisionCd"
  ></app-ura-contract-individual>
</app-main-contents>
